import type { Element } from '@origami/shared'

export interface ElementInfo {
  /** Actual Japanese kanji character (used as a glyph on chips / badges). */
  kanji: string
  /** Romanized Japanese reading (kept for hover/tooltip flavor). */
  romaji: string
  /** English name. */
  en: string
  /** CSS variable reference for background fill on chips / badges. */
  bg: string
  /** CSS variable reference for foreground (text) color on those chips. */
  fg: string
}

/**
 * Per-element display metadata. Background/foreground reference CSS
 * variables defined in styles/tokens.css so they inherit the global
 * palette and can be re-themed centrally.
 */
export const ELEMENT_INFO: Record<Element, ElementInfo> = {
  fire:  { kanji: '火', romaji: 'hi',     en: 'fire',  bg: 'var(--el-fire)',  fg: 'var(--rice)' },
  water: { kanji: '水', romaji: 'mizu',   en: 'water', bg: 'var(--el-water)', fg: 'var(--rice)' },
  wind:  { kanji: '風', romaji: 'kaze',   en: 'wind',  bg: 'var(--el-wind)',  fg: 'var(--ink)'  },
  wood:  { kanji: '木', romaji: 'ki',     en: 'wood',  bg: 'var(--el-wood)',  fg: 'var(--rice)' },
  earth: { kanji: '土', romaji: 'tsuchi', en: 'earth', bg: 'var(--el-earth)', fg: 'var(--rice)' },
}
